import "./CompanyProfileOverviewStyles.scss";
import $ from "jquery";
import { isNotUndefined } from "../FunctionsCore";
// From https://commons.wikimedia.org/wiki/File:Transparent.gif
// Not copyrighted or copyrightable
// @ts-expect-error Ignore
import transparentGifAssetInline from "../resources/Transparent.gif?assetInline";
const companyProfileOverview = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    $(".unverified-address-icon").removeClass("icon");
    const toggleOverviewElements = (element1, element2, element3) => {
        if (isNotUndefined(element1)) {
            element1.classList.toggle("overview-view-hide");
        }
        if (isNotUndefined(element2)) {
            element2.classList.toggle("overview-view-hide");
        }
        if (isNotUndefined(element3)) {
            element3.classList.toggle("overview-view-hide");
        }
    };
    const overviewIndustriesViewMore = (_a = window.document.querySelector(".overview-industries-view-more")) !== null && _a !== void 0 ? _a : void 0;
    const overviewIndustriesViewLess = (_b = window.document.querySelector(".overview-industries-view-less")) !== null && _b !== void 0 ? _b : void 0;
    const overviewViewMoreIndustriesList = (_c = window.document.querySelector(".overview-view-more-industries-list")) !== null && _c !== void 0 ? _c : void 0;
    if (isNotUndefined(overviewIndustriesViewMore)) {
        overviewIndustriesViewMore.addEventListener("click", () => {
            toggleOverviewElements(overviewIndustriesViewMore, overviewIndustriesViewLess !== null && overviewIndustriesViewLess !== void 0 ? overviewIndustriesViewLess : void 0, overviewViewMoreIndustriesList !== null && overviewViewMoreIndustriesList !== void 0 ? overviewViewMoreIndustriesList : void 0);
        });
    }
    if (isNotUndefined(overviewIndustriesViewLess)) {
        overviewIndustriesViewLess.addEventListener("click", () => {
            toggleOverviewElements(overviewIndustriesViewMore !== null && overviewIndustriesViewMore !== void 0 ? overviewIndustriesViewMore : void 0, overviewIndustriesViewLess, overviewViewMoreIndustriesList !== null && overviewViewMoreIndustriesList !== void 0 ? overviewViewMoreIndustriesList : void 0);
        });
    }
    const overviewOtherIndustriesViewMore = (_d = window.document.querySelector(".overview-other-industries-view-more")) !== null && _d !== void 0 ? _d : void 0;
    const overviewOtherIndustriesViewLess = (_e = window.document.querySelector(".overview-other-industries-view-less")) !== null && _e !== void 0 ? _e : void 0;
    const overviewViewMoreOtherIndustriesList = (_f = window.document.querySelector(".overview-view-more-other-industries-list")) !== null && _f !== void 0 ? _f : void 0;
    if (isNotUndefined(overviewOtherIndustriesViewMore)) {
        overviewOtherIndustriesViewMore.addEventListener("click", () => {
            toggleOverviewElements(overviewOtherIndustriesViewMore, overviewOtherIndustriesViewLess !== null && overviewOtherIndustriesViewLess !== void 0 ? overviewOtherIndustriesViewLess : void 0, overviewViewMoreOtherIndustriesList !== null && overviewViewMoreOtherIndustriesList !== void 0 ? overviewViewMoreOtherIndustriesList : void 0);
        });
    }
    if (isNotUndefined(overviewOtherIndustriesViewLess)) {
        overviewOtherIndustriesViewLess.addEventListener("click", () => {
            toggleOverviewElements(overviewOtherIndustriesViewMore, overviewOtherIndustriesViewLess, overviewViewMoreOtherIndustriesList);
        });
    }
    const overviewDescriptionReadMore = (_g = window.document.querySelector(".overview-description-read-more")) !== null && _g !== void 0 ? _g : void 0;
    const overviewDescriptionReadLess = (_h = window.document.querySelector(".overview-description-read-less")) !== null && _h !== void 0 ? _h : void 0;
    if (isNotUndefined(overviewDescriptionReadMore)) {
        overviewDescriptionReadMore.addEventListener("click", () => {
            toggleOverviewElements(overviewDescriptionReadMore, overviewDescriptionReadLess !== null && overviewDescriptionReadLess !== void 0 ? overviewDescriptionReadLess : void 0, void 0);
        });
    }
    if (isNotUndefined(overviewDescriptionReadLess)) {
        overviewDescriptionReadLess.addEventListener("click", () => {
            toggleOverviewElements(overviewDescriptionReadMore !== null && overviewDescriptionReadMore !== void 0 ? overviewDescriptionReadMore : void 0, overviewDescriptionReadLess, void 0);
        });
    }
    for (const element of [overviewIndustriesViewMore, overviewIndustriesViewLess, overviewOtherIndustriesViewMore, overviewOtherIndustriesViewLess, overviewDescriptionReadMore, overviewDescriptionReadLess]) {
        if (isNotUndefined(element)) {
            $(element).css("cursor", "pointer");
        }
    }
    // https://stackoverflow.com/questions/6497992/removing-img-border/31418887#31418887
    $(".overview-popular-search a img").attr("src", transparentGifAssetInline);
    // Print friendly view
    const printView = window.document.querySelector("#company-print-view");
    if (printView !== null) {
        printView.addEventListener("click", (cl) => {
            cl.preventDefault();
            window.print();
        });
    }
};
export { companyProfileOverview };
